export default __webpack_public_path__ + "static/media/clusterhq.a076a2c2.svg";